import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

import RegisterUser from 'components/subscription/RegisterSuscription/registerUser'
import Form from 'providers/FormProvider'
import { defaultPasswordFields } from './RegisterSuscription/subscriptionTypes'

const SubscriptionPass = () => {
  const initValues = {
    input: '',
    inputConfirmation: '',
  }

  return (
    <Flex>
      <Box flex='1' id='right-side' px='6' py='0'>
        <Form initialValues={initValues}>
          <RegisterUser type='password' displayName='contraseña' innitialValues={defaultPasswordFields}/>
        </Form>
      </Box>
    </Flex>
  )
}

export default SubscriptionPass
